export class Lohnverteilung {
  q1MitarbeitendeAnzahl: number;
  q1FrauenAnzahl: number;
  q1MaennerAnzahl: number;
  q1MitarbeitendeAnteil: string;
  q1FrauenAnteil: string;
  q1MaennerAnteil: string;
  q2MitarbeitendeAnzahl: number;
  q2FrauenAnzahl: number;
  q2MaennerAnzahl: number;
  q2MitarbeitendeAnteil: string;
  q2FrauenAnteil: string;
  q2MaennerAnteil: string;
  q3MitarbeitendeAnzahl: number;
  q3FrauenAnzahl: number;
  q3MaennerAnzahl: number;
  q3MitarbeitendeAnteil: string;
  q3FrauenAnteil: string;
  q3MaennerAnteil: string;
  q4MitarbeitendeAnzahl: number;
  q4FrauenAnzahl: number;
  q4MaennerAnzahl: number;
  q4MitarbeitendeAnteil: string;
  q4FrauenAnteil: string;
  q4MaennerAnteil: string;
  q1Wert: number;
  q2Wert: number;
  q3Wert: number;
  q4Wert: number;
  totalFrauenAnteil: string;
  totalMaennerAnteil: string;
  totalFrauenAnzahl: number;
  totalMaennerAnzahl: number;
  totalMitarbeitendeAnzahl: number;
  totalMitarbeitendeAnteil: string;
}
